import { useState, useEffect, useCallback, useRef } from "react";
import {
  getInitialCountry,
  getDefaultCountry,
  detectCountryFromInput,
} from "../utility/phoneNumberUtils";

export const usePhoneNumber = (defaultPhoneNumber) => {
  const [selectedCountry, setSelectedCountry] = useState(() => {
    const detected = getInitialCountry(defaultPhoneNumber);
    return detected || getDefaultCountry();
  });

  // Update selected country when defaultPhoneNumber changes (e.g., after data loads)
  useEffect(() => {
    if (defaultPhoneNumber) {
      const country = getInitialCountry(defaultPhoneNumber);
      if (country) {
        setSelectedCountry(country);
      }
    }
  }, [defaultPhoneNumber]);

  const onCountryChangeHandler = (e) => {
    setSelectedCountry(e.target.value);
  };

  // Auto-detect country from typed input — use ref to keep callback stable
  const selectedCountryRef = useRef(selectedCountry);
  useEffect(() => {
    selectedCountryRef.current = selectedCountry;
  }, [selectedCountry]);

  const onInputChange = useCallback((value) => {
    const detected = detectCountryFromInput(value);
    if (detected && detected !== selectedCountryRef.current) {
      setSelectedCountry(detected);
    }
  }, []);

  return {
    selectedCountry,
    onCountryChangeHandler,
    onInputChange,
    defaultCountry: selectedCountry,
  };
};
